export const ALL_LIMIT_TYPE = 'all';

export const LIMIT_TYPES = {
    DEPOSIT: 'depositlimit',
    SELF_EXCLUSION: 'selfexclude',
    TIMEOUT: 'timeout',
    SESSION_TIMER: 'timer',
    BET: 'bet',
    LOSS: 'loss',
    WITHDRAW: 'withdrawlimit',
    MIN_BALANCE: 'withdrawlimitalob',
    REALITY_CHECK: 'realitycheck',
    LOGIN_AMOUNT: 'loginlimit',
    LOGIN_PERIOD: 'logintimelimit',
    PRODUCT_LOSS: 'productloss',
    PRODUCT_BET: 'productbet',
    SINGLE_BET_LIMIT: 'singlebet'
};

export const UNLIMITED_VALUES = ['9223372036854775807', '92233720368547758.07'];

export const UNLIMITED_DATE_VALUE = 2100;

export const LAST_24_HOURS_VALUE = 1;
export const LAST_3_DAYS_VALUE = 3;
export const LAST_WEEK_VALUE = 7;
export const ANOTHER_PERIOD_VALUE = 0;

export const TIME_PERIODS = [
    { label: 'startDate.24hours', value: LAST_24_HOURS_VALUE },
    { label: 'startDate.3days', value: LAST_3_DAYS_VALUE },
    { label: 'startDate.week', value: LAST_WEEK_VALUE },
    { label: 'startDate.anotherPeriod', value: ANOTHER_PERIOD_VALUE }
];
